import { RoutesNames } from 'affiny-desktop/src/routes/routes-names';
import { Button, Flex, rem, Text, Title } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Logo } from '../../components/desktop/Logo';

interface INotFound {
  hasLogo?: boolean;
  prevLocationPathname?: string;
}

const NotFound = ({ hasLogo = false, prevLocationPathname }: INotFound) => {
  const { t } = useTranslation();
  const history = useHistory();

  const goToRedirection = () => {
    history.push(
      prevLocationPathname ? prevLocationPathname : RoutesNames.Home
    );
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      {...(hasLogo && { height: '100vh' })}
    >
      {hasLogo && <Logo />}
      <Title mt={hasLogo ? rem(50) : 0}>{t('notFound.title')}</Title>
      <Text m="medium">{t('notFound.explanation')}</Text>
      <Button
        onClick={goToRedirection}
        text={t('notFound.goPrevious')}
        variant="contained"
        color="primary"
        size="small"
      />
    </Flex>
  );
};

export default NotFound;
